import React, { forwardRef, useState, useEffect } from 'react';
import DatePicker from 'react-datepicker';
import moment from 'moment';
import { cloneDeep, findIndex, pull, isEqual } from 'lodash';
import PropTypes from 'prop-types';
import * as types from '../../actions/actionTypes';
import {
  useDispatch,
  useSelector,
} from '../../components/common/react-redux-hooks';
import {
  CA_ADD_CONTRACT_STATUS_OPTIONS,
  CA_ADD_CONTRACT_COUNTRY_OPTIONS,
  CA_ADD_CONTRACT_STATE_OPTIONS,
  CA_CREATE_ACCOUNT_VERTICAL_OPTIONS,
  CA_CREATE_ACCOUNT_ACCESS_OPTIONS,
  CA_ADD_CONTRACT_ACCESS_OPTIONS,
  CA_UNIVERSITY_SELECTION_OPTIONS,
  IP_REGEX,
  ERROR_ADDANOTHER_IP,
  ERROR_RANGE_FIELDS_IP,
  ERROR_INVALID_IP,
  CA_ACCOUNT_SELECTION,
  CA_ACCOUNT_SELECTION_NO_CHILD,
} from '../../constants';
import CommonDropdown from '../../components/common/CommonDropdown';
import CustomSelect from '../../components/admin/shared/CustomSelect';
import {
  saveUser,
  getUploadedDocId,
  updateAccountData,
  setAddNewFlag,
  setAddNewEntitlement,
  setIsSummary,
  setUnsavedChangeFlag,
  setEditedAccountData,
  setSupportNav,
  setEditEntitlement,
  getParentAccountList,
} from '../../actions/contractAdminActions';
import {
  validateEmail,
  validatePhoneNumber,
  getDefaultSelected,
  validateLetters,
  validateNumberAndLetter,
} from '../../util/CommonUtils';
import addNewIcon from '../../images/contract-admin-icons/Frame.svg';
import {
  createAccFormValidation,
  resetContractSectionToDefault,
  cleanupLocationSection,
  checkduplicate,
  onSubmitFormValidation,
  getSelectedLocationState,
  getSelectedLocationCountry,
  buildArrayForLoc,
  isSectionBlank,
  hasError,
  isAccountDetailChangedFun,
} from '../../util/ContractAdminUtils';
import CAContractsList from './CAContractsList';
import CALocationsList from './CALocationsList';
import UniversityRangeIp from './IPList/UniversityRangeIp';
import { HeaderContainer } from '../../components/contractAdmin/styledComponents';

const CAAddNew = forwardRef((props, ref) => {
  const dispatch = useDispatch();

  const {
    selectedContractId,
    addAccount,
    addNewFormUnsavedChangeFlag,
    editedAccountData,
    selectedLocationId,
  } = useSelector(state => ({
    selectedContractId: state.contractAdmin.selectedContractId,
    addAccount: state.contractAdmin.addAccount,
    addNewFormUnsavedChangeFlag:
      state.contractAdmin.addNewFormUnsavedChangeFlag,
    editedAccountData: state.contractAdmin.editedAccountData,
    selectedLocationId: state.contractAdmin.selectedLocationId,
  }));

  const [tempContracts, setTempContracts] = useState(
    cloneDeep(addAccount.contracts[0])
  );

  const [userDetails, setUserDetails] = useState(cloneDeep(addAccount));

  useEffect(() => {
    const copyDetails = cloneDeep(userDetails);
    if (!(userDetails.univIpAddresses && userDetails.univIpAddresses.length)) {
      copyDetails.univIpAddresses = [''];
      setUserDetails(copyDetails);
    }
  }, [userDetails]);
  const locArray =
    addAccount.locations.length === 0
      ? cleanupLocationSection()
      : addAccount.locations[0];
  const [tempLocations, setTempLocations] = useState(cloneDeep(locArray));
  const [showFormSuccess, setShowFormSuccess] = useState('');
  const [showFormError, setShowFormError] = useState('');
  const [stateDropdown, setStateDropdown] = useState(true);
  // date changes
  const [startDate, setStartDate] = useState(tempContracts.contractStart);
  const [statusDate, setStatusDate] = useState(tempContracts.statusDate);
  const [endDate, setEndDate] = useState(tempContracts.contractEnd);
  const [endDateRange, setEndDateRange] = useState(moment());
  const [startDateRange, setStartDateRange] = useState(moment());
  const [autoProvision, setAutoProvision] = useState(false);
  const [marketProvision, setMarketProvision] = useState(false);
  const [serverSideErrFlag, setServerSideErrFlag] = useState(false);
  const [selectedLocationIndex, setSelectedLocationIndex] = useState('');
  const [selectedContractIndex, setSelectedContractIndex] = useState('');
  const [contPreviousState, setContPreviousState] = useState(
    addAccount.contracts[0]
  );
  const [isChecked, setIsChecked] = useState(false);
  const [isDisabled, setIsDisabled] = useState(true);
  const [locPreviousState, setLocPreviousState] = useState(locArray);
  // addAnotherContract List ....
  const [contractList, setContractList] = useState([]);
  const [locationList, setLocationList] = useState([]);
  const [excludeClearance, setExcludeClearance] = useState(false);
  // setting default dropdown values...
  const [defaultVerticalDropdown, setDefaultVerticalDropdown] = useState(
    getDefaultSelected(
      userDetails.industryTypeDesc,
      '',
      CA_CREATE_ACCOUNT_VERTICAL_OPTIONS
    )
  );
  const [defaultSelectedAccount, setDefaultSelectedAccount] = useState(
    getDefaultSelected(
      userDetails.accountLinkType,
      userDetails.accountLinkType,
      !dissableChildAcc ? CA_ACCOUNT_SELECTION : CA_ACCOUNT_SELECTION_NO_CHILD
    )
  );
  const [
    defaultSelectedParentAccount,
    setDefaultSelectedParentAccount,
  ] = useState(
    getDefaultSelected(
      userDetails.parentAccountId,
      userDetails.parentAccountId,
      parentAccountList && parentAccountList
    )
  );
  const [defaultAccessDropdown, setDefaultAccessDropdown] = useState(
    getDefaultSelected(
      userDetails.accountType,
      userDetails.accountType,
      CA_CREATE_ACCOUNT_ACCESS_OPTIONS
    )
  );
  const [defaultActiveDropdown, setDefaultActiveDropdown] = useState(
    getDefaultSelected(
      tempContracts.status,
      tempContracts.status,
      CA_ADD_CONTRACT_STATUS_OPTIONS
    )
  );
  const [
    defaultContractAccessDropdown,
    setDefaultContractAccessDropdown,
  ] = useState(
    getDefaultSelected(
      tempContracts.accessedBasedOn,
      tempContracts.accessedBasedOn,
      CA_ADD_CONTRACT_ACCESS_OPTIONS
    )
  );
  const [
    defaultContractUniversityDropdown,
    setDefaultContractUniversityDropdown,
  ] = useState(
    getDefaultSelected(
      tempContracts.universityBackData,
      tempContracts.universityBackData,
      CA_UNIVERSITY_SELECTION_OPTIONS
    )
  );

  const [defaultSelectedState, setDefaultSelectedState] = useState(
    tempContracts.address.state
  );
  const [defaultSelectedCountry, setDefaultSelectedCountry] = useState(
    tempContracts.address.country
  );
  const [
    defaultSelectedLocationState,
    setDefaultSelectedLocationState,
  ] = useState(locArray.state);
  const getDefaultSelectedDate = (accountId, date) => {
    let formatedDate = '';
    if (accountId !== '') {
      formatedDate = moment(date).format('MM/DD/YY');
      return formatedDate;
    }
    return formatedDate;
  };

  const getIndex = (addAccount, selectedContractId) => {
    const index = findIndex(addAccount, { contractId: selectedContractId });
    return index;
  };

  const getLocationIndex = (addAccount, selectedLocationId) => {
    const index = findIndex(addAccount, { locationId: selectedLocationId });
    return index;
  };
  useEffect(() => {
    setUserDetails(addAccount);
    if (ref !== null) {
      ref.current.contractsList = cloneDeep(addAccount.contracts);
      ref.current.locationsList = cloneDeep(addAccount.locations);
      ref.current.userDetails = cloneDeep(addAccount);
    }
    return () => {
      dispatch(setUnsavedChangeFlag(false));
    };
  }, []);

  useEffect(() => {
    const locArr =
      addAccount.locations.length === 0
        ? cleanupLocationSection()
        : addAccount.locations[0];
    setTempLocations(locArr);
    const index =
      addAccount.accountId !== '' &&
      getIndex(addAccount.contracts, selectedContractId) !== -1
        ? getIndex(addAccount.contracts, selectedContractId)
        : 0;
    const locIndex =
      addAccount.accountId !== '' &&
      getLocationIndex(addAccount.locations, selectedLocationId) !== -1
        ? getLocationIndex(addAccount.locations, selectedLocationId)
        : 0;
    setUserDetails(addAccount);
    setTempContracts(addAccount.contracts[index]);
    setAutoProvision(addAccount.contracts[index].autoRenewProvision);
    setMarketProvision(addAccount.contracts[index].marketProvision);
    if (ref !== null) {
      ref.current.tempLocation = locArr;
      ref.current.userDetails = addAccount;
      ref.current.tempContract = addAccount.contracts[index];
    }
    setContPreviousState(addAccount.contracts[index]);
    setStartDate(
      getDefaultSelectedDate(
        addAccount.accountId,
        addAccount.contracts[index].contractStart
      )
    );
    setEndDate(
      getDefaultSelectedDate(
        addAccount.accountId,
        addAccount.contracts[index].contractEnd
      )
    );
    if (addAccount.accountId !== '') {
      if (addAccount.locations.length === 0) {
        setLocPreviousState(cleanupLocationSection());
        setTempLocations(cleanupLocationSection());
        setDefaultSelectedLocationState(getSelectedLocationState(''));
        if (ref !== null) {
          ref.current.tempLocation = cleanupLocationSection();
        }
      } else {
        setSelectedLocationIndex(locIndex);
        setLocationList(addAccount.locations);
        setTempLocations(addAccount.locations[locIndex]);
        setLocPreviousState(addAccount.locations[locIndex]);
        setDefaultSelectedLocationState(
          getSelectedLocationState(addAccount.locations[0].state)
        );
        if (ref !== null) {
          ref.current.tempLocation = addAccount.locations[0];
          ref.current.selectedLocationIndex = 0;
        }
      }
      setSelectedLocationIndex(locIndex);
      setContractList(addAccount.contracts);
      setContractSectionOnEdit(addAccount.contracts[index], index);
      if (addAccount.contracts[index].address.country === 'OTHER') {
        setDefaultSelectedState('');
        setStateDropdown(false);
      } else {
        setStateDropdown(true);
        setDefaultSelectedState(
          getSelectedLocationState(addAccount.contracts[index].address.state)
        );
      }
      setDefaultSelectedCountry(
        getSelectedLocationCountry(addAccount.contracts[index].address.country)
      );
    }
    setDefaultVerticalDropdown(
      getDefaultSelected(
        addAccount.industryTypeDesc,
        addAccount.industryTypeDesc,
        CA_CREATE_ACCOUNT_VERTICAL_OPTIONS
      )
    );

    setDefaultSelectedAccount(
      getDefaultSelected(
        addAccount.accountLinkType,
        addAccount.accountLinkType,
        !dissableChildAcc ? CA_ACCOUNT_SELECTION : CA_ACCOUNT_SELECTION_NO_CHILD
      )
    );
    const selectedParentData = getDefaultSelected(
      addAccount.parentAccountId,
      addAccount.parentAccountId,
      parentAccountList && parentAccountList
    );
    parentAccountList && setDefaultSelectedParentAccount(selectedParentData);
    setDefaultAccessDropdown(
      getDefaultSelected(
        addAccount.accountType,
        addAccount.accountType,
        CA_CREATE_ACCOUNT_ACCESS_OPTIONS
      )
    );
    if (ref !== null) {
      ref.current.contractsList = cloneDeep(addAccount.contracts);
      ref.current.locationsList = cloneDeep(addAccount.locations);
    }
  }, [addAccount]);

  const [parentAccountList, setParentAccountList] = useState();
  const [AccountDissable, setAccountDissable] = useState(false);
  const [dissableChildAcc, setDissableChildAcc] = useState(false);
  useEffect(() => {
    setDefaultSelectedParentAccount(
      getDefaultSelected(
        addAccount.parentAccountId,
        addAccount.parentAccountId,
        parentAccountList && parentAccountList
      )
    );
  }, [parentAccountList]);
  useEffect(() => {
    if (defaultSelectedAccount) {
      if (
        defaultSelectedAccount.label === 'Parent Account' ||
        defaultSelectedAccount.label === 'No Account Link'
      ) {
        setAccountDissable(true);
        setDissableChildAcc(false);
      }
      if (
        addAccount.accountLinkType === 'Parent Link' &&
        userDetails.accountId !== ''
      ) {
        setDissableChildAcc(true);
      }
      if (defaultSelectedAccount.label === 'Child Account') {
        setAccountDissable(false);
      }
    }
  }, [defaultSelectedAccount]);
  const HandleParentAccountList = () => {
    getParentAccountList().then(response => {
      if (response) {
        const Listarray = [];
        response.parentAccounts.map(item => {
          const listObject = { value: item.accountId, label: item.accountName };
          Listarray.push(listObject);
        });
        setParentAccountList(Listarray);
      }
    });
  };
  useEffect(() => {
    HandleParentAccountList();
  }, []);

  const onIpAddressChange = (value, index, field, isRange) => {
    const updatedEditedAccount = cloneDeep(editedAccountData);
    const details = cloneDeep(userDetails);
    const ipArray = details[field] || [];
    const patt = /^[0-9.]+$/;
    dispatch(setUnsavedChangeFlag(false));
    setShowFormError('');
    if (isRange) {
      const ipv41 = value.split('-')[0];
      const ipv42 = value.split('-')[1];
      if (
        (ipv41 && ipv41.trim().length && !patt.test(ipv41.trim())) ||
        (ipv42 && ipv42.trim().length && !patt.test(ipv42.trim()))
      ) {
        setShowFormError('Please enter only numbers and dot');
      } else {
        ipArray[index] = value.trim();
        details[field] = ipArray;
        ref.current.userDetails = details;
        updatedEditedAccount[field] = ipArray;
        dispatch(setEditedAccountData(updatedEditedAccount));
        setUserDetails(details);
      }
    } else if (value && !patt.test(value.trim())) {
      setShowFormError('Please enter only numbers and dot');
    } else {
      ipArray[index] = value.trim();
      details[field] = ipArray;
      ref.current.userDetails = details;
      updatedEditedAccount[field] = ipArray;
      dispatch(setEditedAccountData(updatedEditedAccount));
      setUserDetails(details);
    }
  };

  const addAnotherIp = isRange => {
    const updatedEditedAccount = cloneDeep(editedAccountData);
    const details = cloneDeep(userDetails);
    const ipAddressRegex = IP_REGEX;
    const error = details.univIpAddresses.map(ipRange => {
      let errorMsg = '';
      if (isRange) {
        const ipv41 = ipRange.split('-')[0];
        const ipv42 = ipRange.split('-')[1];
        const isRangeEmpty = !ipv41 && !ipv42;
        const isRangeError = (ipv42 && !ipv41) || (ipv41 && !ipv42);
        const test1 = ipv41 && !ipAddressRegex.test(ipv41.trim());
        const test2 = ipv42 && !ipAddressRegex.test(ipv42.trim());
        errorMsg = isRangeEmpty
          ? ERROR_ADDANOTHER_IP
          : isRangeError
          ? ERROR_RANGE_FIELDS_IP
          : !isRangeEmpty && (test1 || test2) && ERROR_INVALID_IP;
      } else {
        errorMsg = !ipRange
          ? ERROR_ADDANOTHER_IP
          : !ipAddressRegex.test(ipRange.trim()) && ERROR_INVALID_IP;
      }
      return errorMsg;
    })[details.univIpAddresses.length - 1];
    if (error) {
      setShowFormError(error);
    } else {
      details.univIpAddresses.push('');
      ref.current.userDetails = details;
      updatedEditedAccount.univIpAddresses = details.univIpAddresses;
      dispatch(setEditedAccountData(updatedEditedAccount));
      setUserDetails(details);
    }
  };
  const onChange = (e, field, section, subSection) => {
    ref.current.selectedContractIndex = selectedContractIndex;
    ref.current.selectedLocationIndex = selectedLocationIndex;
    ref.current.userDetails = userDetails;
    ref.current.tempContract = tempContracts;

    ref.current.contractsList = contractList;
    ref.current.locationsList = locationList;
    const updatedEditedAccount = cloneDeep(editedAccountData);
    let changedValue = '';
    if (field === 'optInDate' || field === 'optOutDate') {
      const date = e;
      changedValue = date ? moment(date).format('MM-DD-YYYY') : '';
    } else {
      changedValue = e.target !== undefined ? e.target.value : e;
    }
    dispatch(setUnsavedChangeFlag(false));
    if (field !== 'documentId') {
      setShowFormSuccess('');
    }
    setShowFormError('');
    const updateContract = cloneDeep(tempContracts);
    const updateLocation = cloneDeep(tempLocations);
    if (section === undefined) {
      const details = cloneDeep(userDetails);
      const pattUrlCode = /^[A-Za-z.]+$/;
      if (
        field === 'univUrlCode' &&
        changedValue &&
        !pattUrlCode.test(changedValue.trim())
      ) {
        setShowFormError('Please enter only alphabets.');
      } else {
        details[field] = changedValue;
      }

      ref.current.userDetails = details;
      updatedEditedAccount[field] = changedValue;
      if (updatedEditedAccount.industryTypeDesc !== 'University') {
        updateContract.universityBackData = '';
        ref.current.tempContract = updateContract;
        setDefaultContractUniversityDropdown(
          getDefaultSelected(
            tempContracts.universityBackData,
            '',
            CA_UNIVERSITY_SELECTION_OPTIONS
          )
        );
      }
      if (field === 'industryTypeDesc' || field === 'accountType') {
        if (changedValue !== 'University') {
          details.univIpAddresses = [''];
          updatedEditedAccount.univIpAddresses = [''];
        }
      }
      dispatch(setEditedAccountData(updatedEditedAccount));
      setUserDetails(details);
    } else if (section === 'contracts' && subSection === 'address') {
      updateContract[subSection][field] = changedValue;
      ref.current.tempContract = updateContract;
      updatedEditedAccount.contracts[selectedContractIndex] = updateContract;
    } else if (section === 'contracts') {
      updateContract[field] = changedValue;
      ref.current.tempContract = updateContract;
      updatedEditedAccount.contracts[selectedContractIndex] = updateContract;
    } else if (section === 'locations') {
      updateLocation[field] = changedValue;
      ref.current.tempLocation = updateLocation;
      updatedEditedAccount[section][selectedLocationIndex] = updateLocation;
    }
    setTempLocations(updateLocation);
    setTempContracts(updateContract);

    dispatch(setEditedAccountData(updatedEditedAccount));

    if (field === 'contractName') {
      if (changedValue.length > 250) {
        setShowFormError('Contract Name cannot be greater than 250.');
      }
    }

    if (field === 'contractNumber') {
      if (changedValue.length > 20) {
        setShowFormError('Contract Number cannot be greater than 20.');
      }
      if (changedValue.length > 0 && changedValue.length < 20) {
        const value = validateNumberAndLetter(changedValue);
        if (!value) {
          setShowFormError('Contract Number should only alpha numeric');
        }
      }
    }
    if (field === 'studyStart') {
      if (changedValue.length > 50) {
        setShowFormError('Study start cannot be greater than 50.');
      }
    }
    if (field === 'studyEnd') {
      if (changedValue.length > 50) {
        setShowFormError('Study end cannot be greater than 50.');
      }
    }
    if (field === 'zipcode' && changedValue.length > 0) {
      const value = validateNumberAndLetter(changedValue);
      if (!value) {
        setShowFormError('zipcode should only alpha numeric');
      }
    }

    if (field === 'phone' && changedValue.length > 0) {
      const value = validatePhoneNumber(changedValue);
      if (!value) {
        setShowFormError('Phone number should only allow numbers');
      }
    }
    if (field === 'accountName' && changedValue.length > 0) {
      setIsDisabled(false);
    }
    if (field === 'internalContact' && changedValue.length > 0) {
      const value = validateLetters(changedValue);
      if (!value) {
        setShowFormError('Internal contact should only allow alphabet');
      }
    }
    if (field === 'contactName' && changedValue.length > 0) {
      const value = validateLetters(changedValue);
      if (!value) {
        setShowFormError('Contact Name should only allow alphabet');
      }
    }
    if (field === 'contactEmail' && changedValue.length > 1) {
      const value = validateEmail(changedValue);
      if (!value) {
        setShowFormError('Email should only allow alpha numeric and symbols');
      }
    }
    if (
      field === 'state' &&
      tempContracts.address.country === 'OTHER' &&
      section !== 'locations'
    ) {
      setDefaultSelectedState(changedValue);
    }
  };

  const getUploadedDocIdFun = (e, field, section) => {
    const formData = new FormData();
    formData.append('file', e.target.files[0], e.target.value);
    getUploadedDocId(formData).then(response => {
      if (response.data.status === 200) {
        setShowFormSuccess('Contract successfully uploaded');
        onChange(response.data.data.id, field, section);
      }
    });
  };

  const modifiedObjOnSubmit = data => {
    let errorOnSave = '';
    const locArray = buildArrayForLoc(locationList);
    const duplicateLocation = checkduplicate(locationList, {
      locationName: tempLocations.locationName,
    });
    const removedEmptyIPV4 =
      data.univIpAddresses && data.univIpAddresses.filter(data => data.length);

    const [isContractBlank] = isSectionBlank(tempContracts, tempLocations);
    const details = cloneDeep(data);
    details.univIpAddresses =
      data.univIpAddresses && data.univIpAddresses.length
        ? removedEmptyIPV4
        : null;
    const duplicateContract = checkduplicate(contractList, {
      contractName: tempContracts.contractName,
    });
    if (isContractBlank === false) {
      if (selectedContractIndex === '') {
        if (duplicateContract) {
          errorOnSave = 'contract name already exist';
        } else {
          details.contracts = [...contractList, tempContracts];
        }
      } else if (selectedContractIndex !== '') {
        const conIndex = findIndex(contractList, {
          contractName: tempContracts.contractName,
        });
        if (conIndex !== selectedContractIndex && conIndex !== -1) {
          errorOnSave = 'contract name already exist';
        } else {
          const updateList = cloneDeep(contractList);
          updateList[selectedContractIndex] = tempContracts;
          // setContractList(updateList);
          details.contracts = updateList;
        }
      }
    } else {
      details.contracts = contractList;
    }
    if (locArray) {
      details.locations = [];
    } else if (
      selectedLocationIndex === '' &&
      !isEqual(tempLocations, cleanupLocationSection())
    ) {
      if (duplicateLocation) {
        errorOnSave = 'location name already exist';
      } else {
        details.locations = [...locationList, tempLocations];
      }
    } else if (selectedLocationIndex !== '') {
      const locIndex = findIndex(locationList, {
        locationName: tempLocations.locationName,
      });
      if (locIndex !== selectedLocationIndex && locIndex !== -1) {
        errorOnSave = 'location name already exist';
      } else {
        const updateList = cloneDeep(locationList);
        updateList[selectedLocationIndex] = tempLocations;
        details.locations = updateList;
      }
    } else {
      const updateList = cloneDeep(locationList);
      details.locations = updateList;
    }
    details.excludedFromClearence = excludeClearance;
    return [details, errorOnSave];
  };

  const copyContractLocation = e => {
    if (isChecked) {
      const location = cleanupLocationSection();
      setTempLocations(cleanupLocationSection());
      setDefaultSelectedLocationState('');
    } else {
      setDefaultSelectedLocationState('');

      setTempLocations(cleanupLocationSection());

      let temp = tempLocations;
      temp.companyName = userDetails.accountName;
      temp.city = tempContracts.address.city;
      temp.contactName = tempContracts.address.internalContact;
      if (tempContracts.address.country === 'USA') {
        temp.state = tempContracts.address.state;
      } else {
        temp.state = '';
      }

      let stateArr = temp.state.split('-');
      let stateVal = stateArr[1];
      let stateObj;
      if (stateVal) {
        stateObj = {
          value: temp.state,
          label: temp.state,
          sortcode: stateVal.trim(),
        };
        setDefaultSelectedLocationState(stateObj);
      }
      temp.locationName = `${
        tempContracts.address.city ? tempContracts.address.city : ''
      }`;
      if (stateObj) {
        temp.locationName = `${temp.locationName} - ${stateObj.sortcode}`;
      }
      setLocationList(locationList, {
        locationName: ref.current.tempLocation,
      });
      ref.current.tempLocation = temp;
      setTempLocations(temp);

      let dupCount = 2;
      while (
        checkduplicate(locationList, {
          locationName: tempLocations.locationName,
        })
      ) {
        temp.locationName = `${
          tempContracts.address.city ? tempContracts.address.city : ''
        } `;

        if (stateObj) {
          temp.locationName = `${temp.locationName} - ${stateObj.sortcode} (${dupCount})`;
        } else {
          temp.locationName = `${temp.locationName} (${dupCount})`;
        }
        dupCount += 1;
      }
    }
    setIsChecked(!isChecked);
  };

  const arraymove = (arr, fromIndex, toIndex) => {
    const element = arr.contracts[fromIndex];
    arr.contracts.splice(fromIndex, 1);
    arr.contracts.splice(toIndex, 0, element);
    return arr;
  };

  const setData = data => {
    dispatch(updateAccountData(data));
  };

  const handleSubmit = e => {
    let errorMsg = '';
    let onSaveError = '';
    let modifiedDataForSave = {};
    e.preventDefault();
    const [isContractBlank, isLocationBlank] = isSectionBlank(
      tempContracts,
      tempLocations
    );
    const isContractOrLocationsBlank =
      isContractBlank === false &&
      contractList.length &&
      isLocationBlank === false &&
      locationList.length;
    const contractstemp = tempContracts;
    contractstemp.address.state =
      typeof defaultSelectedState === 'object' && defaultSelectedState !== null
        ? defaultSelectedState.value
        : defaultSelectedState;

    // first time user save without contract section then validation check..
    if (contractList.length === 0 || locationList.length === 0) {
      errorMsg = onSubmitFormValidation(
        userDetails,
        contractstemp,
        tempLocations,
        contractList,
        locationList
      );
    } else if (isContractOrLocationsBlank) {
      errorMsg = onSubmitFormValidation(
        userDetails,
        tempContracts,
        tempLocations,
        contractList,
        locationList
      );
    }
    if (errorMsg) {
      setShowFormError(errorMsg);
    } else {
      const [modifiedSaveObj, onsaveError] = modifiedObjOnSubmit(userDetails);
      onSaveError = onsaveError;
      modifiedDataForSave = modifiedSaveObj;
      setShowFormError(onSaveError);
    }
    if (!hasError(errorMsg, onSaveError)) {
      saveUser(modifiedDataForSave).then(response => {
        if (response && response.data && response.data.status !== 500) {
          const data = response.data.data;
          setContractList(data.contracts);
          setLocationList(data.locations);
          setData(response.data.data);
          dispatch({
            type: types.SET_SELECTED_CONTRACT_ID,
            payload: tempContracts.contractId
              ? tempContracts.contractId
              : data.contracts[0].contractId,
          });
          dispatch({
            type: types.SET_SELECTED_LOCATION_ID,
            payload: tempLocations.locationId
              ? tempLocations.locationId
              : data.locations[0].locationId,
          });
          dispatch(setEditedAccountData(data));
          setServerSideErrFlag(false);
          setShowFormError('');
          dispatch(setUnsavedChangeFlag(false));

          setShowFormSuccess('Save Successful');
          setIsChecked(false);
          setIsDisabled(true);
        } else if (response.data && response.data.status === 500) {
          setServerSideErrFlag(true);
          setShowFormError('failed to save');
        } else {
          setShowFormSuccess('');
          setServerSideErrFlag(true);
          setShowFormError(response.error);
        }
      });
    }
  };

  const handleSwitch = (e, field) => {
    const updateContract = cloneDeep(tempContracts);
    if (field === 'autoRenewProvision') {
      updateContract[field] = !autoProvision;
      ref.current.tempContract = updateContract;
      setAutoProvision(!autoProvision);
    } else {
      updateContract[field] = !marketProvision;
      ref.current.tempContract = updateContract;
      setMarketProvision(!marketProvision);
    }
    setTempContracts(updateContract);
  };

  useEffect(() => {
    setExcludeClearance(userDetails.excludedFromClearence);
  }, [userDetails]);
  const handleExcludeClearance = () => {
    setExcludeClearance(!excludeClearance);
  };
  const dropdownClickFn = (e, field, section, subSection) => {
    if (e.value === 'OTHER') {
      setDefaultSelectedState('');
      setStateDropdown(false);
    }
    if (e.value === 'USA') {
      setStateDropdown(true);
      setDefaultSelectedState('');
    }
    if (field === 'industryTypeDesc') {
      setDefaultVerticalDropdown(e);
    }
    if (field === 'accountType') {
      setDefaultAccessDropdown(e);
    }
    if (field === 'accountLinkType') {
      setDefaultSelectedAccount(e);
    }
    if (field === 'parentAccountId') {
      setDefaultSelectedParentAccount(e);
    }

    if (field === 'status') {
      setStatusDate('');
      const updateContract = cloneDeep(tempContracts);
      updateContract[statusDate] = '';
      ref.current.tempContract = updateContract;
      setTempContracts(updateContract);
      setDefaultActiveDropdown(e);
    }
    if (field === 'accessedBasedOn') {
      setDefaultContractAccessDropdown(e);
    }
    if (field === 'universityBackData') {
      if (e.value === 'TWOYRBACKDATA') {
        setDefaultContractAccessDropdown(CA_ADD_CONTRACT_ACCESS_OPTIONS[1]);
      }

      setDefaultContractUniversityDropdown(e);
    }
    if (field === 'state' && section !== 'locations') {
      setDefaultSelectedState(e);
    }
    if (field === 'country') {
      setDefaultSelectedCountry(e);
    }
    if (field === 'state' && section === 'locations') {
      setDefaultSelectedLocationState(e);
    }

    onChange(e.value, field, section, subSection);
  };

  const handleStatusDateChange = date => {
    setStatusDate(date ? moment(date).format('MM/DD/YY') : '');
    onChange(
      date ? moment(date).format('MM-DD-YYYY') : '',
      'statusDate',
      'contracts'
    );
  };

  const handleStartDate = startDate => {
    setStartDate(startDate ? moment(startDate).format('MM/DD/YY') : '');
    setEndDateRange(startDate ? moment(startDate).format('MM/DD/YY') : '');
    onChange(
      moment(startDate).format('MM-DD-YYYY'),
      'contractStart',
      'contracts'
    );
  };

  const handleEndDate = endDate => {
    setEndDate(endDate ? moment(endDate).format('MM/DD/YY') : '');
    setStartDateRange(endDate ? moment(endDate).format('MM/DD/YY') : '');
    onChange(moment(endDate).format('MM-DD-YYYY'), 'contractEnd', 'contracts');
  };

  const cleanupContractSection = section => {
    if (section === 'contract') {
      ref.current.selectedContractIndex = '';
      setSelectedContractIndex('');
      if (userDetails.accountId === '') {
        setTempContracts(addAccount.contracts[0]);
        setAutoProvision(addAccount.contracts[0].autoRenewProvision);
        setMarketProvision(addAccount.contracts[0].marketProvision);
      } else {
        const contract = resetContractSectionToDefault();
        setTempContracts(contract);
        setAutoProvision(contract.autoRenewProvision);
        setMarketProvision(contract.marketProvision);
        ref.current.tempContract = contract;
      }
      setDefaultActiveDropdown(
        getDefaultSelected(
          tempContracts.status,
          'A',
          CA_ADD_CONTRACT_STATUS_OPTIONS
        )
      );
      setDefaultContractAccessDropdown(
        getDefaultSelected(
          tempContracts.accessedBasedOn,
          'NATIONALSTUDY',
          CA_ADD_CONTRACT_ACCESS_OPTIONS
        )
      );
      setDefaultContractUniversityDropdown(
        getDefaultSelected(
          tempContracts.universityBackData,
          '',
          CA_UNIVERSITY_SELECTION_OPTIONS
        )
      );
      setStartDateRange(moment());
      setEndDateRange(moment());
      setDefaultSelectedState('');
      setDefaultSelectedCountry('');
      setStartDate('');
      setEndDate('');
      setStateDropdown(true);
    }
    if (section === 'location') {
      ref.current.selectedLocationIndex = '';
      setSelectedLocationIndex('');
      if (userDetails.accountId === '') {
        setDefaultSelectedLocationState('');
        setTempLocations(cleanupLocationSection());
        ref.current.tempLocation = cleanupLocationSection();
        // setTempLocations(addAccount.locations[0]);
      } else {
        const location = cleanupLocationSection();
        setTempLocations(location);
        ref.current.tempLocation = location;
        setDefaultSelectedLocationState('');
      }
    }
  };

  const addAnotherConLocFun = (section, previousData = null) => {
    setShowFormSuccess('');
    dispatch(setUnsavedChangeFlag(false));
    const updatedEditedAccount = cloneDeep(editedAccountData);
    const duplicateLocation = checkduplicate(locationList, {
      locationName: tempLocations.locationName,
    });
    const duplicateContract = checkduplicate(contractList, {
      contractName: tempContracts.contractName,
    });
    const errorMsg = createAccFormValidation(userDetails, tempContracts);
    if (section === 'addContract' && previousData === null) {
      if (errorMsg) {
        setShowFormError(errorMsg);
      } else {
        setContPreviousState(resetContractSectionToDefault());
        if (selectedContractIndex === '') {
          if (duplicateContract) {
            setShowFormError('contract name already exist');
          } else {
            setContractList([...contractList, tempContracts]);
            cleanupContractSection('contract');
            updatedEditedAccount.contracts = [...contractList, tempContracts];
            dispatch(setEditedAccountData(updatedEditedAccount));
            ref.current.contractsList = updatedEditedAccount.contracts;
            ref.current.tempContract = resetContractSectionToDefault();
          }
        } else {
          const conIndex = findIndex(contractList, {
            contractName: tempContracts.contractName,
          });
          if (conIndex !== selectedContractIndex && conIndex !== -1) {
            setShowFormError('contract name already exist');
          } else {
            const updateList = cloneDeep(contractList);
            updateList[selectedContractIndex] = tempContracts;
            updatedEditedAccount.contracts[
              selectedContractIndex
            ] = tempContracts;
            dispatch(setEditedAccountData(updatedEditedAccount));

            ref.current.contractsList = updatedEditedAccount.contracts;
            ref.current.tempContract = resetContractSectionToDefault();
            setContractList(updateList);
            cleanupContractSection('contract');
          }
        }
      }
    } else if (section === 'addContract' && previousData !== null) {
      if (errorMsg) {
        setShowFormError(errorMsg);
      } else {
        setContPreviousState(resetContractSectionToDefault());
        if (selectedContractIndex === '') {
          if (duplicateContract) {
            setShowFormError('contract name already exist');
          } else {
            setContractList([...contractList, tempContracts]);
            cleanupContractSection('contract');
            updatedEditedAccount.contracts = [...contractList, tempContracts];
            dispatch(setEditedAccountData(updatedEditedAccount));
            ref.current.contractsList = updatedEditedAccount.contracts;
            ref.current.tempContract = resetContractSectionToDefault();
          }
        } else {
          const conIndex = findIndex(contractList, {
            contractName: tempContracts.contractName,
          });
          if (conIndex !== selectedContractIndex && conIndex !== -1) {
            setShowFormError('contract name already exist');
          } else {
            const updateList = cloneDeep(contractList);
            updateList[selectedContractIndex] = tempContracts;
            updatedEditedAccount.contracts[
              selectedContractIndex
            ] = tempContracts;
            dispatch(setEditedAccountData(updatedEditedAccount));

            ref.current.contractsList = updatedEditedAccount.contracts;
            ref.current.tempContract = resetContractSectionToDefault();
            setContractList(updateList);
            cleanupContractSection('contract');
          }
        }
      }

      const {
        address: {
          apt,
          state,
          city,
          streetAddress,
          country,
          internalContact,
          phone,
          zipCode,
        },
      } = previousData.temp;
      ref.current.tempContract.address.apt = apt;
      ref.current.tempContract.address.state = state;
      ref.current.tempContract.address.city = city;
      ref.current.tempContract.address.streetAddress = streetAddress;
      ref.current.tempContract.address.country = country;
      ref.current.tempContract.address.internalContact = internalContact;
      ref.current.tempContract.address.phone = phone;
      ref.current.tempContract.address.zipCode = zipCode;

      const {
        temp: {
          accessedBasedOn,
          universityBackData,
          autoRenewProvision,
          marketProvision,
        },
        tempContractAccess,
        tempAccessDropdown,
      } = previousData;
      ref.current.tempContract.accessedBasedOn = accessedBasedOn;
      ref.current.tempContract.universityBackData = universityBackData;
      ref.current.tempContract.autoRenewProvision = autoRenewProvision;
      ref.current.tempContract.marketProvision = marketProvision;

      setDefaultSelectedCountry(country);
      setDefaultSelectedState(state);
      setDefaultContractAccessDropdown(tempContractAccess);
      setDefaultAccessDropdown(tempAccessDropdown);
      setAutoProvision(autoRenewProvision);
      setMarketProvision(marketProvision);
    }
    if (section === 'addLocation' && previousData === null) {
      setIsDisabled(false);
      if (isChecked) {
        setIsChecked(false);
        setDefaultSelectedLocationState('');
      }
      if (tempLocations.locationName === '' && section === 'addLocation') {
        setShowFormError('Location name required');
      } else {
        setLocPreviousState(cleanupLocationSection());
        if (selectedLocationIndex === '') {
          if (duplicateLocation) {
            setShowFormError('location name already exist');
          } else {
            setLocationList([...locationList, tempLocations]);
            updatedEditedAccount.locations = [...locationList, tempLocations];
            dispatch(setEditedAccountData(updatedEditedAccount));
            ref.current.locationsList = updatedEditedAccount.locations;
            ref.current.tempLocation = cleanupLocationSection();
            cleanupContractSection('location');
            setDefaultSelectedLocationState('');
          }
        } else {
          const locIndex = findIndex(locationList, {
            locationName: tempLocations.locationName,
          });
          if (locIndex === selectedLocationIndex || locIndex === -1) {
            const updateList = cloneDeep(locationList);
            updateList[selectedLocationIndex] = tempLocations;
            updatedEditedAccount.locations = updateList;
            dispatch(setEditedAccountData(updatedEditedAccount));
            ref.current.locationsList = updatedEditedAccount.locations;
            ref.current.tempLocation = cleanupLocationSection();
            setLocationList(updateList);
            cleanupContractSection('location');
          } else {
            setShowFormError('location name already exist');
          }
        }
      }
    }
  };

  const duplicateCurrentContract = () => {
    const previousData = {
      temp: tempContracts,
      tempContractAccess: defaultContractAccessDropdown,
      tempCountry: defaultSelectedCountry,
      tempState: defaultSelectedState,
      tempAccessDropdown: defaultAccessDropdown,
      tempAutoProvision: autoProvision,
      tempMarketProvision: marketProvision,
    };

    addAnotherConLocFun('addContract', previousData);
  };

  const setContractSectionOnEdit = (currentTempdata, index) => {
    setSelectedContractIndex(index);
    if (ref !== null) {
      ref.current.selectedContractIndex = index;
    }
    setStartDateRange(currentTempdata.contractEnd);
    setEndDateRange(currentTempdata.contractStart);
    setStartDate(moment(currentTempdata.contractStart).format('MM/DD/YY'));
    setEndDate(moment(currentTempdata.contractEnd).format('MM/DD/YY'));
    setStatusDate(moment(currentTempdata.statusDate).format('MM/DD/YY'));
    setDefaultSelectedCountry(
      getSelectedLocationCountry(currentTempdata.address.country)
    );
    setDefaultActiveDropdown(
      getDefaultSelected(
        currentTempdata.status,
        currentTempdata.status,
        CA_ADD_CONTRACT_STATUS_OPTIONS
      )
    );
    setDefaultContractAccessDropdown(
      getDefaultSelected(
        currentTempdata.accessedBasedOn,
        currentTempdata.accessedBasedOn,
        CA_ADD_CONTRACT_ACCESS_OPTIONS
      )
    );
    setDefaultContractUniversityDropdown(
      getDefaultSelected(
        currentTempdata.universityBackData,
        currentTempdata.universityBackData,
        CA_UNIVERSITY_SELECTION_OPTIONS
      )
    );
    if (currentTempdata.address.country === 'USA') {
      setStateDropdown(true);
      setDefaultSelectedState(
        getSelectedLocationState(currentTempdata.address.state)
      );
    } else {
      setDefaultSelectedState('');
      setStateDropdown(false);
    }
  };

  const editLocationAndContract = (currentTempdata, index, section) => {
    // edit location section...
    if (section === 'location') {
      setIsDisabled(true);

      if (selectedLocationIndex === '') {
        setTempLocations(currentTempdata);
        setDefaultSelectedLocationState(
          getSelectedLocationState(currentTempdata.state)
        );
        setSelectedLocationIndex(index);
      } else {
        const locIndex = findIndex(locationList, {
          locationName: tempLocations.locationName,
        });
        if (locIndex !== selectedLocationIndex && locIndex !== -1) {
          setShowFormError('location name already exist');
        } else {
          setSelectedLocationIndex(index);
          setLocPreviousState(addAccount.locations[index]);
          setTempLocations(currentTempdata);
          const updateList = cloneDeep(locationList);
          updateList[selectedLocationIndex] = tempLocations;
          setDefaultSelectedLocationState(
            getSelectedLocationState(currentTempdata.state)
          );
          setLocationList(updateList);
        }
      }
    }
    // edit contrcat section...
    if (section === 'contract') {
      ref.current.tempContract = currentTempdata;
      // setContPreviousState(currentTempdata);
      // edit for new account ...
      if (selectedContractIndex === '') {
        setContPreviousState(currentTempdata);
        setTempContracts(currentTempdata);
        setContractSectionOnEdit(currentTempdata, index);
      } else {
        const conIndex = findIndex(contractList, {
          contractName: tempContracts.contractName,
        });
        if (conIndex !== selectedContractIndex && conIndex !== -1) {
          setShowFormError('contract name already exist');
        } else {
          setContPreviousState(addAccount.contracts[index]);
          setContractSectionOnEdit(currentTempdata, index);
          setTempContracts(currentTempdata);
          setMarketProvision(currentTempdata.marketProvision);
          setAutoProvision(currentTempdata.autoRenewProvision);
          const updateList = cloneDeep(contractList);
          updateList[selectedContractIndex] = tempContracts;
          setContractList(updateList);
        }
      }
    }
  };

  const cancel = section => {
    setShowFormError(false);
    dispatch(setUnsavedChangeFlag(false));
    const editedData = cloneDeep(editedAccountData);
    if (section === 'contract') {
      setTempContracts(contPreviousState);
      setAutoProvision(contPreviousState.autoRenewProvision);
      setMarketProvision(contPreviousState.marketProvision);
      ref.current.tempContract = contPreviousState;
      if (selectedContractIndex === '') {
        const index = findIndex(editedData.contracts, {
          contractName: tempContracts.contractName,
        });
        editedData.contracts[index] = resetContractSectionToDefault();
        dispatch(setEditedAccountData(editedData));
        cleanupContractSection('contract');
      } else {
        editedData.contracts[selectedContractIndex] = contPreviousState;
        dispatch(setEditedAccountData(editedData));
        setContractSectionOnEdit(contPreviousState, selectedContractIndex);
      }
    } else {
      ref.current.tempLocation = locPreviousState;
      setTempLocations(locPreviousState);
      if (selectedLocationIndex === '') {
        const index = findIndex(editedData.locations, {
          locationName: tempLocations.locationName,
        });
        editedData.locations[index] = cleanupLocationSection();
        setDefaultSelectedLocationState(
          getSelectedLocationState(locPreviousState.state)
        );
        cleanupContractSection('location');
      } else {
        editedData.locations[selectedLocationIndex] = locPreviousState;

        setTempLocations(locPreviousState);
        setDefaultSelectedLocationState(
          getSelectedLocationState(locPreviousState.state)
        );
      }
      dispatch(setEditedAccountData(editedData));
    }
  };

  const deleteLocation = (currentTempdata, index) => {
    setShowFormSuccess('');
    dispatch(setUnsavedChangeFlag(false));
    // nothing selected for edit...
    const updateEditedAccount = cloneDeep(editedAccountData);
    const updateList = cloneDeep(locationList);
    if (selectedLocationIndex === '') {
      pull(updateList, updateList[index]);
      updateEditedAccount.locations = updateList;
      ref.current.locationsList = updateList;
      dispatch(setEditedAccountData(updateEditedAccount));
      setLocationList(updateList);
    } else {
      // deleted index is greater than edited
      if (selectedLocationIndex < index) {
        pull(updateList, updateList[index]);
        updateEditedAccount.locations = updateList;
        ref.current.locationsList = updateList;

        setLocationList(updateList);
      } else {
        pull(updateList, updateList[index]);
        updateEditedAccount.locations = updateList;
        ref.current.locationsList = updateList;

        setLocationList(updateList);
        setSelectedLocationIndex(selectedLocationIndex - 1);
      }
      dispatch(setEditedAccountData(updateEditedAccount));
    }
  };
  function setEntitlementFlag() {
    const checkUnSavedChanges = !isAccountDetailChangedFun(ref, addAccount);
    if (checkUnSavedChanges) {
      dispatch(setSupportNav('Contract', 'Entitlement Creation'));
      dispatch(setAddNewFlag(false));
      dispatch(setAddNewEntitlement(true));
      dispatch(setIsSummary(false));
      dispatch(setEditEntitlement(false));
    } else {
      dispatch(setUnsavedChangeFlag(true));
    }
  }
  function setSummaryFlag() {
    const checkUnSavedChanges = !isAccountDetailChangedFun(ref, addAccount);
    if (checkUnSavedChanges) {
      dispatch(setSupportNav('Contract', 'Summary'));
      dispatch(setAddNewFlag(false));
      dispatch(setAddNewEntitlement(false));
      dispatch(setIsSummary(true));
      dispatch(setEditEntitlement(false));
    } else {
      dispatch(setUnsavedChangeFlag(true));
    }
  }
  return (
    <div>
      <form onSubmit={handleSubmit}>
        <div
          ref={ref}
          className="large-12 medium-12 small-12 columns ca-add-user"
          data-test="CAAddNewAccount"
        >
          <div className="large-6 medium-6 small-6 columns add-user-left-block">
            <div className="row">
              {userDetails.accountId === '' && (
                <span className="ca-add-user-form-heading">
                  Create New Account
                </span>
              )}
              {userDetails.accountId !== '' && (
                <HeaderContainer>
                  <span className="ca-add-user-form-heading">
                    Selected Account
                  </span>
                  <div>
                    <span className="ca-radio-btn">
                      <input
                        type="radio"
                        name="ec"
                        checked={excludeClearance}
                        onClick={handleExcludeClearance}
                      />
                    </span>
                    <span>&nbsp;</span>
                    <span className="ca-radio-heading">
                      Exclude From Clearance
                    </span>
                  </div>
                </HeaderContainer>
              )}
              {addNewFormUnsavedChangeFlag &&
                !showFormError &&
                !showFormSuccess && (
                  <span className="error-message">
                    Please save the changes before proceeding
                  </span>
                )}
              {showFormError !== null && (
                <span className="error-message">{showFormError}</span>
              )}
              {showFormSuccess !== null && showFormSuccess !== '' && (
                <span className="success-message">{showFormSuccess}</span>
              )}
            </div>
            <div className="row outer-css ca-add-user first-bock">
              <div className="sa-col1">
                <input
                  id="accountName"
                  name="accountName"
                  className="form-control"
                  placeholder="Account Name"
                  title="Account Name"
                  type="text"
                  value={userDetails.accountName}
                  onChange={e => onChange(e, 'accountName')}
                  disabled={userDetails.accountId !== ''}
                />
              </div>
              <div
                className="col2 leftBorder add-user-form-dropdown"
                title="Vertical"
              >
                <CommonDropdown
                  placeHolder="Vertical"
                  itemClickFn={e => dropdownClickFn(e, 'industryTypeDesc')}
                  listData={CA_CREATE_ACCOUNT_VERTICAL_OPTIONS}
                  defaultSelected={defaultVerticalDropdown}
                />
              </div>
              <div className="col3 add-user-form-dropdown" title="Access">
                <CommonDropdown
                  placeHolder="Access"
                  itemClickFn={e => dropdownClickFn(e, 'accountType')}
                  listData={CA_CREATE_ACCOUNT_ACCESS_OPTIONS}
                  defaultSelected={defaultAccessDropdown}
                />
              </div>

              <div
                className="col06 add-user-form-dropdown"
                title="Account Link"
              >
                <CommonDropdown
                  placeHolder="No Account Link"
                  itemClickFn={e => dropdownClickFn(e, 'accountLinkType')}
                  listData={
                    !dissableChildAcc
                      ? CA_ACCOUNT_SELECTION
                      : CA_ACCOUNT_SELECTION_NO_CHILD
                  }
                  defaultSelected={defaultSelectedAccount}
                />
              </div>
              <div
                className="col06 add-user-form-dropdown"
                title="Parent Account"
              >
                {parentAccountList && (
                  <CommonDropdown
                    placeHolder="Parent Account List"
                    itemClickFn={e => dropdownClickFn(e, 'parentAccountId')}
                    listData={parentAccountList}
                    defaultSelected={
                      AccountDissable
                        ? {
                            value: 'Parent Account List',
                            label: 'Parent Account List',
                          }
                        : defaultSelectedParentAccount
                    }
                    disabled={AccountDissable}
                  />
                )}
              </div>

              <div className="sa-col1 cs-add-university-code">
                <input
                  id="universityCode"
                  name="universityCode"
                  className="form-control"
                  placeholder="University Code"
                  title="University Code"
                  type="text"
                  value={userDetails.univUrlCode}
                  onChange={e => onChange(e, 'univUrlCode')}
                  disabled={
                    !(
                      userDetails.industryTypeDesc === 'University' &&
                      userDetails.accountType === 'UNIVERSITY'
                    )
                  }
                />
              </div>

              {userDetails.univIpAddresses && (
                <UniversityRangeIp
                  userDetails={userDetails}
                  dropdownClickFn={dropdownClickFn}
                  onIpAddressChange={onIpAddressChange}
                />
              )}
            </div>
            <br className="clearboth" />

            <div className="row">
              <span>
                <span
                  onClick={() => addAnotherIp(true)}
                  className="ca-add-user-form-heading"
                >
                  <button type="button">
                    <img
                      src={addNewIcon}
                      alt="Add New"
                      className="ca-add-another-btn"
                    />
                  </button>
                  Add Another IP Range
                </span>
              </span>
            </div>

            <div className="row">&nbsp;</div>
            <div className="row">
              <span className="ca-add-user-form-heading">New Contracts(s)</span>
            </div>
            <div className="row outer second-block">
              <div className="col1 ca-add-col-section-second-row">
                <input
                  id="contractName"
                  name="contractName"
                  className="form-control"
                  placeholder="Contract Name"
                  title="Contract Name"
                  type="text"
                  value={tempContracts.contractName || ''}
                  onChange={e => onChange(e, 'contractName', 'contracts')}
                  contentEditable
                />
              </div>
              <div className="col2">
                <input
                  id="contractNumber"
                  name="contractNumber"
                  className="form-control"
                  placeholder="Contract Number"
                  title="Contract Number"
                  type="text"
                  value={tempContracts.contractNumber || ''}
                  onChange={e => onChange(e, 'contractNumber', 'contracts')}
                />
              </div>
              <div className="col3 add-user-form-dropdown" title="Status">
                <CommonDropdown
                  placeHolder="Active"
                  // fieldName="activeStatus"
                  itemClickFn={e => dropdownClickFn(e, 'status', 'contracts')}
                  listData={CA_ADD_CONTRACT_STATUS_OPTIONS}
                  defaultSelected={defaultActiveDropdown}
                  title="status"
                />
              </div>
              <div className="col4 ca-add-col-section-second-row">
                {tempContracts.status === 'A' && (
                  <input
                    id="status"
                    name="status"
                    className="form-control"
                    placeholder="On Hold/Disabled"
                    title="On Hold/Disabled"
                    type="text"
                    disabled
                  />
                )}
                {tempContracts.status === 'H' && (
                  <DatePicker
                    selected={statusDate ? new Date(statusDate) : statusDate}
                    placeholderText={
                      tempContracts.status === 'H' ? ' On Hold' : 'Disabled'
                    }
                    title={
                      tempContracts.status === 'H' ? ' On Hold' : 'Disabled'
                    }
                    onChange={handleStatusDateChange}
                    dropdownMode="select"
                    className="custom-date-picker--control"
                    startOpen={statusDate ? false : true}
                    minDate={moment()}
                  />
                )}
                {tempContracts.status === 'D' && (
                  <DatePicker
                    selected={statusDate ? new Date(statusDate) : statusDate}
                    placeholderText={
                      tempContracts.status === 'H' ? ' On Hold' : 'Disabled'
                    }
                    title={
                      tempContracts.status === 'H' ? ' On Hold' : 'Disabled'
                    }
                    onChange={handleStatusDateChange}
                    dropdownMode="select"
                    className="custom-date-picker--control"
                    startOpen={statusDate ? false : true}
                    minDate={moment()}
                  />
                )}
              </div>
              <div className="col5 ca-add-col-section-second-row">
                <DatePicker
                  selected={
                    (userDetails.accountId !== '' && startDate) ||
                    (userDetails.accountId === '' && startDate)
                      ? new Date(startDate)
                      : startDate
                  }
                  placeholderText="Start Date"
                  title="Start Date"
                  onChange={handleStartDate}
                  yearDropdownItemNumber={15}
                  showYearDropdown
                  dropdownMode="select"
                  maxDate={startDateRange && new Date(startDateRange)}
                  scrollableYearDropdown
                  className="custom-date-picker--control"
                />
              </div>
              <div className="col6">
                <DatePicker
                  selected={
                    (userDetails.accountId !== '' && endDate) ||
                    (userDetails.accountId === '' && endDate)
                      ? new Date(endDate)
                      : endDate
                  }
                  placeholderText="End Date"
                  title="End Date"
                  scrollableYearDropdown
                  onChange={handleEndDate}
                  minDate={endDateRange && new Date(endDateRange)}
                  yearDropdownItemNumber={15}
                  showYearDropdown
                  dropdownMode="select"
                  className="custom-date-picker--control"
                />
              </div>
              <div className="col7">
                <input
                  id="studyStart"
                  name="studyStart"
                  className="form-control"
                  type="text"
                  title="Study Start"
                  maxLength="50"
                  placeholder="Study Start"
                  value={tempContracts.studyStart || ''}
                  onChange={e => onChange(e, 'studyStart', 'contracts')}
                />
              </div>
              <div className="col7">
                <input
                  type="text"
                  id="studyEnd"
                  name="studyEnd"
                  className="form-control"
                  title="Study End"
                  maxLength="50"
                  placeholder="Study End"
                  value={tempContracts.studyEnd || ''}
                  onChange={e => onChange(e, 'studyEnd', 'contracts')}
                />
              </div>
              <div className="col7 add-user-form-dropdown">
                <CommonDropdown
                  // fieldName="activeStatus"
                  itemClickFn={e =>
                    dropdownClickFn(e, 'accessedBasedOn', 'contracts')
                  }
                  listData={CA_ADD_CONTRACT_ACCESS_OPTIONS}
                  defaultSelected={defaultContractAccessDropdown}
                  title="Access"
                />
              </div>
              <div className="col7 add-user-form-dropdown">
                <CommonDropdown
                  // fieldName="activeStatus"
                  disabled={!(userDetails.industryTypeDesc === 'University')}
                  placeHolder="University Selections Only"
                  itemClickFn={e =>
                    dropdownClickFn(e, 'universityBackData', 'contracts')
                  }
                  listData={CA_UNIVERSITY_SELECTION_OPTIONS}
                  defaultSelected={defaultContractUniversityDropdown}
                  title="Access"
                />
              </div>
              <br className="clearboth" />
            </div>
            {tempContracts.lastNationalStudy && (
              <div className="study-success-message">
                {tempContracts.lastNationalStudy}
              </div>
            )}
            <div className="row">&nbsp;</div>
            <div className="row outer ca-add-user third-bock">
              <div className="col1">
                {' '}
                <input
                  id="street"
                  name="street"
                  className="form-control"
                  placeholder="Street Address"
                  title="Street Address"
                  type="text"
                  value={tempContracts.address.streetAddress || ''}
                  onChange={e =>
                    onChange(e, 'streetAddress', 'contracts', 'address')
                  }
                />
              </div>
              <div className="col2">
                <input
                  id="apt"
                  name="apt"
                  className="form-control"
                  placeholder="Suit, Office, Apt, etc"
                  title="Suit, Office, Apt, etc"
                  type="text"
                  onChange={e => onChange(e, 'apt', 'contracts', 'address')}
                  value={tempContracts.address.apt || ''}
                />
              </div>
              <div
                className="col3 ca-add-col-section-second-row ca-form-country"
                title="Country"
              >
                <CustomSelect
                  placeholder="Country"
                  tabName="ca"
                  onChange={e =>
                    dropdownClickFn(e, 'country', 'contracts', 'address')
                  }
                  options={CA_ADD_CONTRACT_COUNTRY_OPTIONS}
                  defaultSelectedItem={defaultSelectedCountry}
                />
              </div>
              <div className="col4">
                {' '}
                <input
                  id="city"
                  name="city"
                  className="form-control"
                  placeholder="City"
                  title="City"
                  type="text"
                  value={tempContracts.address.city || ''}
                  onChange={e => onChange(e, 'city', 'contracts', 'address')}
                />
              </div>
              <div
                className="col5 ca-add-col-section-second-row ca-form-country"
                title="State"
              >
                {stateDropdown === true && (
                  <CustomSelect
                    tabName="ca"
                    placeholder="State"
                    onChange={e =>
                      dropdownClickFn(e, 'state', 'contracts', 'address')
                    }
                    options={CA_ADD_CONTRACT_STATE_OPTIONS}
                    defaultSelectedItem={defaultSelectedState}
                  />
                )}
                {stateDropdown === false && (
                  <input
                    id="state"
                    name="State"
                    className="form-control"
                    placeholder="State"
                    type="text"
                    onChange={e => onChange(e, 'state', 'contracts', 'address')}
                    value={defaultSelectedState}
                  />
                )}
              </div>
              <div className="col6">
                <input
                  id="zipcode"
                  name="zipcode"
                  className="form-control"
                  placeholder="Zipcode"
                  title="Zipcode"
                  type="text"
                  value={tempContracts.address.zipCode || ''}
                  onChange={e => onChange(e, 'zipCode', 'contracts', 'address')}
                />
              </div>
              <div className="col7">
                <input
                  id="Phone"
                  name="Phone"
                  title="Phone"
                  className="form-control"
                  placeholder="Phone"
                  type="text"
                  value={tempContracts.address.phone || ''}
                  onChange={e => onChange(e, 'phone', 'contracts', 'address')}
                />
              </div>
              <div className="col8">
                <input
                  id="status"
                  name="status"
                  className="form-control"
                  placeholder="Internal Contact"
                  title="Internal Contact"
                  type="text"
                  value={tempContracts.address.internalContact || ''}
                  onChange={e =>
                    onChange(e, 'internalContact', 'contracts', 'address')
                  }
                />
              </div>
              <br className="clearboth" />
            </div>
            <div className="row ">&nbsp;</div>
            <div className="row fourth-block">
              <div className="fourth-block-sec-first">
                <div className="fourth-block-sec-first-col1">
                  <DatePicker
                    selected={
                      tempContracts.optInDate
                        ? new Date(
                            moment(tempContracts.optInDate).format('MM/DD/YY')
                          )
                        : ''
                    }
                    placeholderText="Opt In/Start Clause"
                    title="Opt In/Start Clause"
                    scrollableYearDropdown
                    onChange={e => onChange(e, 'optInDate', 'contracts')}
                    yearDropdownItemNumber={15}
                    showYearDropdown
                    dropdownMode="select"
                    className="custom-date-picker--control"
                  />
                </div>
                <div className="fourth-block-sec-first-col2">
                  <DatePicker
                    selected={
                      tempContracts.optOutDate
                        ? new Date(
                            moment(tempContracts.optOutDate).format('MM/DD/YY')
                          )
                        : ''
                    }
                    placeholderText="Opt Out/End Clause"
                    title="Opt Out/End Clause"
                    scrollableYearDropdown
                    onChange={e => onChange(e, 'optOutDate', 'contracts')}
                    yearDropdownItemNumber={15}
                    showYearDropdown
                    dropdownMode="select"
                    className="custom-date-picker--control"
                  />
                </div>
              </div>
              <div className="fourth-block-sec-second">
                <div>
                  <span className="ca-radio-btn">
                    <input
                      type="radio"
                      name="ap"
                      checked={autoProvision}
                      onClick={e =>
                        handleSwitch(e, 'autoRenewProvision', 'contracts')
                      }
                    />
                  </span>
                  <span>&nbsp;</span>
                  <span className="ca-radio-heading">Autorenew Provision</span>
                </div>
                <div>
                  <span className="ca-radio-btn">
                    <input
                      type="radio"
                      name="mp"
                      checked={marketProvision}
                      onClick={e =>
                        handleSwitch(e, 'marketProvision', 'contracts')
                      }
                    />
                  </span>
                  <span>&nbsp;</span>
                  <span className="ca-radio-heading">Marketing Provision</span>
                </div>
              </div>
            </div>
            <div className="row">&nbsp;</div>
            <div className="row fifth-block">
              <span className="col1">
                <span
                  onClick={() => addAnotherConLocFun('addContract')}
                  className="ca-add-user-form-heading"
                >
                  <button type="button">
                    <img
                      src={addNewIcon}
                      alt="Add New"
                      className="ca-add-another-btn"
                    />
                  </button>
                  Add Another Contract
                </span>
                <br />
                <span
                  onClick={() => duplicateCurrentContract()}
                  className="ca-add-user-form-heading"
                >
                  <button type="button">
                    <img
                      src={addNewIcon}
                      alt="Add New"
                      className="ca-add-another-btn"
                    />
                  </button>
                  Duplicate This Contract
                </span>
              </span>
              <span className="col2">
                <div className="ca-btn-upload">
                  <span>
                    <input
                      type="file"
                      name="fileupload"
                      id="fileupload"
                      title="Upload Contract"
                      onChange={e =>
                        getUploadedDocIdFun(e, 'documentId', 'contracts')
                      }
                    />
                    <button
                      type="button"
                      className="button contract-upload-btn"
                    >
                      Upload Contract
                    </button>
                  </span>
                </div>
                <div className="ca-btn-upload">
                  <button
                    type="button"
                    title="Reset Contract"
                    className="button cancel"
                    onClick={() => cancel('contract')}
                  >
                    Reset
                  </button>
                </div>
              </span>
            </div>
            <div className="row-checkbox">
              <div>
                <span className="ca-add-user-form-heading">
                  New Location(s)
                </span>
              </div>
              <div>
                <label htmlFor={`checkbox`}>
                  <span className="ca-checkbox-label">
                    Use Contract Information
                  </span>
                </label>
                <input
                  className="ca-checkbox-box"
                  type="checkbox"
                  id="checkbox"
                  value=""
                  disabled={isDisabled}
                  checked={isChecked}
                  onChange={e => copyContractLocation(e)}
                />
              </div>
            </div>
            <div className="row outer six-block">
              <div className="col1">
                <input
                  id="locationName"
                  name="locationName"
                  className="form-control"
                  placeholder="Location Name"
                  title="Location Name"
                  type="text"
                  value={tempLocations.locationName}
                  onChange={e => onChange(e, 'locationName', 'locations')}
                />
              </div>
              <div className="col2">
                <input
                  id="companyName"
                  name="companyName"
                  className="form-control"
                  placeholder="Company Name"
                  title="Company Name"
                  type="text"
                  value={tempLocations.companyName || ''}
                  onChange={e => onChange(e, 'companyName', 'locations')}
                />
              </div>
              <div className="col3">
                <input
                  id="city"
                  name="city"
                  className="form-control"
                  placeholder="City Required"
                  title="City"
                  type="text"
                  value={tempLocations.city || ''}
                  onChange={e => onChange(e, 'city', 'locations')}
                />
              </div>
              <div className="col4 ca-add-col-section-second-row" title="State">
                <CustomSelect
                  tabName="ca"
                  placeholder="State"
                  onChange={e => dropdownClickFn(e, 'state', 'locations')}
                  options={CA_ADD_CONTRACT_STATE_OPTIONS}
                  defaultSelectedItem={defaultSelectedLocationState}
                />
              </div>
              <div className="col5">
                <input
                  id="contactName"
                  name="contactName"
                  className="form-control"
                  placeholder="Contact Name"
                  title="Contact Name"
                  type="text"
                  value={tempLocations.contactName || ''}
                  onChange={e => onChange(e, 'contactName', 'locations')}
                />
              </div>
              <div className="col6">
                <input
                  id="contactEmail"
                  name="contactEmail"
                  className="form-control"
                  placeholder="Contact Email"
                  title="Contact Email"
                  type="text"
                  // value={tempLocations.contactEmail === null ? ''  : tempLocations.contactEmail}
                  value={tempLocations.contactEmail || ''}
                  onChange={e => onChange(e, 'contactEmail', 'locations')}
                />
              </div>
            </div>
            <div className="row">&nbsp;</div>
            <div className="row">
              <span
                onClick={() => addAnotherConLocFun('addLocation')}
                className="ca-add-user-form-heading"
              >
                <button type="button">
                  <img
                    src={addNewIcon}
                    alt="Add New"
                    className="ca-add-another-btn"
                  />
                </button>
                Add Another Location
              </span>
              <span className="loc-cancel-btn">
                <button
                  type="button"
                  title="Reset Location"
                  className="button cancel"
                  onClick={() => cancel('location')}
                >
                  Reset
                </button>
              </span>
            </div>
            <div className="row">&nbsp;</div>
            <div className="row seventh-block">
              <span className="ca-note-pad-section">
                <textarea
                  id="notes"
                  name="notes"
                  className="form-control"
                  placeholder="Notepad"
                  title="Notepad"
                  type="text"
                  value={tempContracts.notes || ''}
                  onChange={e => onChange(e, 'notes', 'contracts')}
                />
              </span>
            </div>

            <div className="row ca-messages ninth-block">
              {addNewFormUnsavedChangeFlag &&
                !showFormError &&
                !showFormSuccess && (
                  <span className="error-message">
                    Please save the changes before proceeding
                  </span>
                )}
              {showFormError !== null && (
                <span className="error-message">{showFormError}</span>
              )}
              {showFormSuccess !== null && showFormSuccess !== '' && (
                <span className="success-message">{showFormSuccess}</span>
              )}
            </div>
            <div className="row  ninth-block">
              <span className="col1">
                <button type="submit" className="btn btn-default" title="Save">
                  Save
                </button>
              </span>
              <span className="col2">
                {userDetails.accountId !== '' && (
                  <button
                    type="button"
                    className="button primary"
                    onClick={setSummaryFlag}
                  >
                    View Existing Entitlement
                  </button>
                )}
              </span>
              <span className="col2">
                {userDetails.accountId !== '' && (
                  <button
                    type="button"
                    onClick={setEntitlementFlag}
                    className="button primary"
                  >
                    Create New Entitlement
                  </button>
                )}
              </span>
            </div>
          </div>
          <div className="large-6 medium-6 small-6 columns add-user-right-block">
            <div className="row contractsListBlock">
              <CAContractsList
                data={contractList}
                selectedIndex={selectedContractIndex}
                setEditData={editLocationAndContract}
              />
            </div>
            <div className="row locationsListBlock">
              <CALocationsList
                data={locationList}
                selectedIndex={selectedLocationIndex}
                setEditData={editLocationAndContract}
                deleteLocation={deleteLocation}
                id="locationComp"
              />
            </div>
          </div>
        </div>
      </form>
    </div>
  );
});

CAAddNew.propTypes = {
  addAccount: PropTypes.instanceOf(Object),
};

export default CAAddNew;
